import React, { useState, useEffect, useRef } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null }
  });
  
  const sectionRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );
    
    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ ...formStatus, submitting: true });
    
    // Simulação de envio de formulário
    setTimeout(() => {
      setFormStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: "Mensagem enviada com sucesso!" }
      });
      
      // Reset form after successful submission
      setFormState({
        name: '',
        email: '',
        message: ''
      });
      
      // Reset success message after 5 seconds
      setTimeout(() => {
        setFormStatus({
          submitted: false,
          submitting: false,
          info: { error: false, msg: null }
        });
      }, 5000);
    }, 1500);
  };

  return (
    <section className="contact" id="contact" ref={sectionRef}>
      <div className="contact-background">
        <div className="contact-gradient-1"></div>
        <div className="contact-gradient-2"></div>
      </div>
      
      <div className="contact-container">
        <h2 className={`contact-title ${isVisible ? 'animate-in' : ''}`}>
          <span className="word-wrapper">
            {'Entre'.split('').map((char, index) => <span key={index} style={{ animationDelay: `${0.1 + index * 0.05}s` }}>{char}</span>)}
          </span>
          <span className="word-wrapper">
            {'em'.split('').map((char, index) => <span key={index} style={{ animationDelay: `${0.1 + ('Entre'.length + 1 + index) * 0.05}s` }}>{char}</span>)}
          </span>
          <span className="text-gradient word-wrapper">
            {'Contato'.split('').map((char, index) => <span key={index} style={{ animationDelay: `${0.1 + ('Entre'.length + 1 + 'em'.length + 1 + index) * 0.05}s` }}>{char}</span>)}
          </span>
        </h2>
        
        <div className="contact-content">
          <div className={`contact-info ${isVisible ? 'animate-in' : ''}`} style={{ animationDelay: '0.2s' }}>
            <h3>Vamos conversar</h3>
            <p>Preencha o formulário ao lado ou entre em contato através dos canais abaixo:</p>
            
            <div className="contact-method">
              <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <div>
                <h4>Email</h4>
                <a href="mailto:eduardo.santosm1202@gmail.com">eduardo.santosm1202@gmail.com</a>
              </div>
            </div>
            
            <div className="contact-method">
              <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <div>
                <h4>Telefone</h4>
                <a href="tel:+5511999999999">+55 (14) 99662-9885</a>
              </div>
            </div>
            
            <div className="contact-method">
              <svg className="contact-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <div>
                <h4>Localização</h4>
                <p>São Paulo, SP - Brasil</p>
              </div>
            </div>
            
            <div className="social-links">
                <a href="https://github.com/eduardomnzs" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 3c0 0-1.03-.31-3.4 1.35A19.77 19.77 0 0 0 12 5.31c-2.76 0-5.24-.7-7-2.34C3.09 3 2 3.31 2 3.31A5.07 5.07 0 0 0 2.09 4.77A5.44 5.44 0 0 0 4 9.14c0 5.44 3.3 6.61 6.44 7A3.37 3.37 0 0 0 11 18.13V22"></path>
                  </svg>
                </a>
                <a href="https://www.instagram.com/edu.mnzs_/" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/in/edumnzs" target="_blank" rel="noopener noreferrer" className="footer-social-link">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                    <rect x="2" y="9" width="4" height="12"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                  </svg>
                </a>
            </div>
          </div>
          
          <form 
            className={`contact-form ${isVisible ? 'animate-in' : ''}`} 
            style={{ animationDelay: '0.4s' }}
            onSubmit={handleSubmit}
          >
            <div className="form-group">
              <label htmlFor="name">Nome</label>
              <input 
                type="text" 
                id="name" 
                name="name" 
                placeholder="Seu nome completo" 
                required 
                value={formState.name}
                onChange={handleChange}
                className={formState.name ? 'has-value' : ''}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="Seu melhor email" 
                required 
                value={formState.email}
                onChange={handleChange}
                className={formState.email ? 'has-value' : ''}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="message">Mensagem</label>
              <textarea 
                id="message" 
                name="message" 
                placeholder="Como posso ajudar você?" 
                rows="5" 
                required
                value={formState.message}
                onChange={handleChange}
                className={formState.message ? 'has-value' : ''}
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="btn-primary"
              disabled={formStatus.submitting}
            >
              {formStatus.submitting ? (
                <span className="loading-spinner"></span>
              ) : formStatus.submitted ? (
                'Enviado com sucesso!'
              ) : (
                'Enviar Mensagem'
              )}
            </button>
            
            {formStatus.info.error && (
              <div className="form-error">{formStatus.info.msg}</div>
            )}
            
            {formStatus.submitted && !formStatus.info.error && (
              <div className="form-success">{formStatus.info.msg}</div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;